import { Box, styled } from '@mui/material';
import { MatxLogo } from 'app/components';
import useSettings from 'app/hooks/useSettings';
import { Span } from './Typography';

const BrandRoot = styled(Box)(() => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	padding: '20px 18px 20px 29px',
}));

const StyledSpan = styled(Span)(({ mode }) => ({
	fontSize: 18,
	marginLeft: '.5rem',
	display: mode === 'compact' ? 'none' : 'block',
}));

const Brand = ({ children }) => {
	const { settings } = useSettings();
	const leftSidebar = settings.layout1Settings.leftSidebar;
	const { mode } = leftSidebar;

	return (
		<BrandRoot>
			<Box display='flex' alignItems='center'>
				{/* <MatxLogo /> */}
				<img
					src='https://www.musafirbazar.com/static/media/mb.ff1a1c86dd49c134632a.jpeg'
					style={{ height: 25 }}
				/>
				<StyledSpan mode={mode} className='sidenavHoverShow'>
					Musafir Bazar
				</StyledSpan>
			</Box>

			<Box className='sidenavHoverShow' sx={{ display: mode === 'compact' ? 'none' : 'block' }}>
				{children || null}
			</Box>
		</BrandRoot>
	);
};

export default Brand;
